<template lang="pug">
  transition(name='modal')
    .modal-mask
      .modal-wrapper
        form.modal-container.column(
          @submit.prevent='onSubmit'
          v-on-clickaway='closeModal'
          :class='{ "dots-container": isCurrentState(0), "thanks-container": isCurrentState(2) }'
        )
          .modal-header.width-100
            button.close-button(type='button' @click='closeModal')
              img(src='@/assets/ic_cross.svg' alt='close')
          transition(name='slide-fade' mode='out-in')
            .modal-content.column.center.space-between(v-if='isCurrentState(0)' key='step1')
              .content-header.column.center
                h3.text-xbig
                  | {{ $t('presentationTab.state1.title') }}
                h3.title-medium
                  | {{ $t('presentationTab.state1.subtitle') }}
              stars.stars-section(:stars='stars' :size='"xbig"' :enableEdit='true' @setStars='setStars')
            .modal-content.column.center.space-between.m4-bottom-7(v-if='isCurrentState(1)' key='step2')
              .content-header.column.center
                h3.text-xbig
                  | {{ $t('presentationTab.state2.title') }}
                h3.title-medium
                  | {{ setSubtitle }}
              .checkbox-section.row.top
                feedback-button(
                  :feedback='feedback'
                  v-for="(item, index) in feedback"
                  :key='index'
                  :index='index'
                  :item='item'
                  @setFeedbackStatus='setFeedbackStatus'
                )
              span.text-normal.self-start.m4-bottom-3
                | {{ $t('presentationTab.leaveMessage') }}
              textarea.comment.text-normal(
                v-model='comment'
                :placeholder='$t("presentationTab.commentPlaceholder")'
                :maxlength='reviewCommentMaxLength'
              )
            .text-container.column.center.middle(v-if='isCurrentState(2)' key='step3')
              h2.title-big
                | {{ $t('presentationTab.thanks') }}
          transition(name='fade')
            button.primary-button(
              type='submit'
              v-if='!isFinalStep'
              :class='isCurrentState(0) ? "self-center" : "self-end"'
            )
              | {{ $t('presentationTab.rate') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'

import Stars from '@/components/Stars'
import FeedbackButton from '@/components/FeedbackButton'

import { feedbackOptions, positiveReviewMinimumStars, reviewCommentMaxLength } from '../../utils/constants'
import { rateResource } from '../../services/ResourceService'

export default {
  components: {
    Stars,
    FeedbackButton
  },
  mixins: [ clickaway ],
  data() {
    return {
      currentState: 0,
      stars: 1,
      comment: '',
      feedback: feedbackOptions.map(option => ({ ...option })),
      reviewCommentMaxLength
    }
  },
  computed: {
    ...mapGetters([
      'resourceId'
    ]),
    setSubtitle() {
      return this.stars >= positiveReviewMinimumStars
        ? this.$t('presentationTab.state2.subtitleLike')
        : this.$t('presentationTab.state2.subtitleImprove')
    },
    isFinalStep() {
      return this.currentState === 2
    }
  },
  methods: {
    ...mapActions([
      'hideElement'
    ]),
    closeModal() {
      this.hideElement({ element: 'feedbackModal' })
      if (this.currentState === 2) this.$emit('reload')
      this.currentState = 0
      this.feedback = feedbackOptions
    },
    setStars(newStars) {
      this.stars = newStars
    },
    setFeedbackStatus(index) {
      this.feedback[index].status = !this.feedback[index].status
    },
    onSubmit() {
      if (this.currentState === 1) {
        const categories = this.feedback.reduce(
          (output, option, index) => option.status ? output.concat(index + 1) : output,
          []
        )
        rateResource(this.stars, categories, this.resourceId, this.comment)
      }
      this.currentState++
    },
    isCurrentState(state) {
      return this.currentState === state
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';
@import '../../scss/variables/sizes';

.modal-mask {
  background-color: $black-translusent;
  display: block;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  transition: opacity .3s ease;
  width: 100%;
  z-index: 80;
}

.modal-wrapper {
  display: flex;
  height: 100%;
}

.modal-container {
  background-color: $white;
  border-radius: 10px;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  margin: auto;
  max-width: 600px;
  min-height: 320px;
  overflow: hidden;
  padding: 50px;
  transition: all .3s ease;
  width: 100%;

  .close-button {
    display: block;
    height: 20px;
    margin-left: auto;
  }

  .stars-section {
    margin: 60px auto;
  }

  .checkbox-section {
    margin: 40px auto 50px;
  }
}

.dots-container {
  background: $white url('../../assets/il_dots.svg') no-repeat 95% 95%;
}

.thanks-container {
  background: $white url('../../assets/il_thanks.svg') no-repeat center;
  height: 100%;
  max-height: 325px;
  width: 100%;

  .text-container {
    height: 100%;
  }
}

.comment {
  background-color: $white;
  border: 1px solid $gray;
  border-radius: 6px;
  box-sizing: border-box;
  height: 100px;
  padding: 14px;
  resize: none;
  width: 100%;
}

.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .3s ease;
}

.slide-fade-enter {
  transform: translateX(200px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-200px);
  opacity: 0;
}
</style>
